const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const ActivityList = () => import(/* webpackChunkName: "activity" */ './view/index.vue');
const ActivityDetail = () => import(/* webpackChunkName: "activity" */ './view/detail.vue');

export const ROUTE_NAME_ACTIVITY = {
    INDEX: 'ActivityList',
    DETAIL: 'ActivityDetail'
};

export default [
    {
        path: '/app/:appId/activity',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_ACTIVITY.INDEX,
                component: ActivityList,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/detail',
                name: ROUTE_NAME_ACTIVITY.DETAIL,
                component: ActivityDetail,
                meta: { requiresAuth: true }
            }
        ]
    }
];
